import React, { ForwardedRef } from "react";
import clsx from "clsx";
import MuiMenu from "@mui/material/Menu";

import { useMenuStyles, useStyles } from "./Menu.styles";
import { MenuProps } from "./Menu.types";

function Menu(props: MenuProps, ref: ForwardedRef<HTMLDivElement>) {
  const { children, className, size, ...other } = props;

  const menuClasses = useMenuStyles();

  const classes = useStyles();

  const rootClassName = clsx(className, {
    [classes.sizeSmall]: size === "small",
    [classes.sizeLarge]: size === "large",
  });

  return (
    <MuiMenu
      {...other}
      ref={ref}
      className={rootClassName}
      classes={menuClasses}
    >
      {children}
    </MuiMenu>
  );
}

export default React.forwardRef(Menu);
